interface TextNode {
  data: string;
  type: SchemaNode["type"];
}

interface ElementNode {
  children?: Node[];
  type: SchemaNode["type"];
}

type Node = TextNode | ElementNode;

export function createDOMElement(object: Node): HTMLElement {
  const element = document.createElement(object.type);
  if ("attribs" in object && object.attribs) {
    Object.entries(object.attribs).forEach(([key, value]) => {
      if (typeof key === "string" && typeof value === "string") {
        element.setAttribute(key, value);
      }
    });
  }
  if ("children" in object) {
    object.children?.forEach(child => {
      element.append(createDOMElement(child));
    });
  } else if ("data" in object) {
    element.textContent = object.data;
  }
  return element;
}
